import React, { useRef, useState, useEffect } from "react";
import { format } from "date-fns";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import { InlineWidget } from "react-calendly";
import { AiOutlineClockCircle } from "react-icons/ai";
import { BsCameraVideo } from "react-icons/bs";

export default function BookingSection() {
	const [date, setDate] = useState<Date | null>(null);
	const query = useRef("");

	const handleChange = (selected: Date | undefined) => {
		if (!selected) return;
		setDate(selected);

		const formattedMonth = format(selected, "yyyy-MM");
		const formattedDate = format(selected, "yyyy-MM-dd");

		query.current = `?month=${formattedMonth}&date=${formattedDate}`;
	};
	const calendlyLink =
		"https://calendly.com/salesbox-meet/video-ondemand-services";

	useEffect(() => {
		const widget = document.getElementById("calendly-widget");
		if (widget) {
			const iframe = widget.querySelector("iframe");
			if (iframe) {
				iframe.style.borderRadius = "20px";
			}
		}
	}, []);

	return (
		<div className="border flex-col md:flex-row my-10 flex rounded-2xl h-fit bg-white">
			<div className=" md:flex  border-r max-w-[350px] mr-2 flex-col items-center justify-start">
				<div className="flex flex-col w-fit items-start p-6">
					<div className=" md:flex   mr-2 flex-col items-center justify-start">
						<img src="/logo.png" className="mb-10" />
						<h1 className="text-black text-sm font-normal">
							Meet The <br />
							<span className="text-black font-bold text-md lg:text-3xl">
								Video Production Experts
							</span>
						</h1>
						{/* <a
              rel="noreferrer"
              href="#calendly-widget"
              className="bg-brand-green mt-10 text-white mr-auto max-lg:py-3 font-normal flex mb-5 justify-center items-center text-xl lg:h-16 rounded-full px-10 border border-brand-green hover:border-black hover:bg-white hover:text-brand-green transition-all duration-200 ease-in-out whitespace-nowrap"
            >
              Meet the Experts
            </a> */}
						<p className="mt-5 self-start">
							Book a time with our sales expert
							<br />
							<p className="text-lime-500 mt-2">
								Select the best date for you.
							</p>
						</p>
					</div>
				</div>
			</div>
			<a
				href={calendlyLink}
				target="_blank"
				className="pl-1 pr-1 "
				rel="noopener noreferrer"
			>
				<div className="lg:w-[400px]" id="calendly-widget">
					<InlineWidget
						url={calendlyLink}
						pageSettings={{
							backgroundColor: "fff",
							hideEventTypeDetails: true,
							hideLandingPageDetails: true,
							hideGdprBanner: true,
							primaryColor: "#146FF8",
							textColor: "#4d5055",
						}}
					/>
				</div>
			</a>
		</div>
	);
}

const CalendlyWidget = () => {
	const calendlyLink = "https://calendly.com/salesbox-meet/ai-ondemand";

	return (
		<div className="border flex-col md:flex-row  flex rounded-2xl h-fit bg-white">
			<div className=" md:flex  border-r max-w-[350px] mr-2 flex-col items-center justify-start">
				<div className="flex flex-col w-fit items-start p-6">
					<h2 className="text-3xl text-black font-semibold  gap-2 text-center flex flex-row items-center justify-center">
						Revenue Growth
					</h2>
					<div className="flex gap-4 items-center mt-10 justify-center">
						<AiOutlineClockCircle className="text-2xl" />
						<h5 className="font-bold">30 min</h5>
					</div>
					<div className="flex gap-4 mt-3  items-center justify-center">
						<BsCameraVideo className="w-[20px]   h-[24px] " />
						<div className="font-bold">
							<h5>Web conferencing</h5>
						</div>
					</div>
					<div>
						<h4 className="text-black font-normal text-xl  text-start mt-16">
							Meet with an AI Growth <br />
							Specialist to learn more{" "}
						</h4>
					</div>
					<a
						target="_blank"
						href={calendlyLink}
						className="mx-auto lg:mx-none hover:bg-transparent hover:text-black transition-all duration-200 ease-inout border border-black bg-black w-full max-w-[200px] text-center items-center flex justify-center h-12 mt-16 text-white rounded-full"
					>
						Book a Call
					</a>
				</div>
			</div>
			<a
				href={calendlyLink}
				target="_blank"
				className="pl-1 pr-1 "
				rel="noopener noreferrer"
			>
				<div className="lg:w-[400px]" id="calendly-widget">
					<InlineWidget
						url={calendlyLink}
						pageSettings={{
							backgroundColor: "fff",
							hideEventTypeDetails: true,
							hideLandingPageDetails: true,
							hideGdprBanner: true,
							primaryColor: "#146FF8",
							textColor: "#4d5055",
						}}
					/>
				</div>
			</a>
		</div>
	);
};
